
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemePaymentDialog extends Serenity.EntityDialog<SchemePaymentRow, any> {
        protected getFormKey() { return SchemePaymentForm.formKey; }
        protected getIdProperty() { return SchemePaymentRow.idProperty; }
        protected getLocalTextPrefix() { return SchemePaymentRow.localTextPrefix; }
        protected getService() { return SchemePaymentService.baseUrl; }
        protected getDeletePermission() { return SchemePaymentRow.deletePermission; }
        protected getInsertPermission() { return SchemePaymentRow.insertPermission; }
        protected getUpdatePermission() { return SchemePaymentRow.updatePermission; }

        protected form = new SchemePaymentForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.hideEditorLabel(this.form.SchemePaymentDetails);
            this.form.CustomerName.getGridField().find('.caption').attr('Style', 'display:none');

            this.form.SchemeId.changeSelect2(e => {
                var schemeamount = 0;
                 
                SchemeMasterService.Retrieve({
                    EntityId: parseInt(this.form.SchemeId.value)
                }, response => {
                    schemeamount = response.Entity.SchemeAmount
                }, { async: false });
                this.form.Amount.value = schemeamount;
                
            });
            this.form.POSCustomerId.changeSelect2(e => {
                var cid = parseInt(this.form.POSCustomerId.value);

                if (cid > 0) {
                    let CustomerDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: cid }, response => { CustomerDetails = response.Entity }, { async: false });
                    this.form.POSCustomerId.value = CustomerDetails.POSCustomerId.toString();
                    this.form.Address.value = CustomerDetails.Address;
                    //this.form.Mobile.value = CustomerDetails.Mobile;
                    this.form.PanNumber.value = CustomerDetails.PanNumber;
                }
            });



        }

        protected onDialogOpen() {
            super.onDialogOpen();

            var fieldEditor: JQuery = this.form.POSCustomerId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $('<a><b/>...</a>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.PosCustomerMasterGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Customer"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.PosCustomerMasterRow[]) => {

                this.form.POSCustomerId.value = selectedItems[0].POSCustomerId.toString();
                this.form.Address.value = selectedItems[0].Address;
              //  this.form.Mobile.value = selectedItems[0].Mobile;
                this.form.PanNumber.value = selectedItems[0].PanNumber;
            }
            pickerDialog.dialogOpen();

        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var receipts = this.form.SchemePaymentDetails.getItems();
            var totalreceipts = 0;
            for (var i = 0; i < receipts.length; i++) {
                totalreceipts += receipts[i].Amount;

            }
            if (this.form.Amount.value != totalreceipts) {
                Q.notifyError(Q.text('Total Receipts and Amount do not match'), '', null);
                return false;

            } else {
                return true;
            }
        }
    }
}